import { render, staticRenderFns } from "./AssetLinkedFiles.vue?vue&type=template&id=54bb51c1&scoped=true"
import script from "./AssetLinkedFiles.vue?vue&type=script&lang=js"
export * from "./AssetLinkedFiles.vue?vue&type=script&lang=js"
import style0 from "./AssetLinkedFiles.vue?vue&type=style&index=0&id=54bb51c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bb51c1",
  null
  
)

export default component.exports